import 'froala-editor/css/froala_editor.min.css';
import 'froala-editor/css/themes/gray.min.css';
import 'froala-editor/css/plugins/colors.min.css';
import 'froala-editor/css/plugins/table.min.css';
import 'froala-editor/css/plugins/image.min.css';
import '../../scss/components/froala.scss';

// TODO: this should live in croppie component once we get css in Roots working
import '../../scss/components/croppie.scss';

import 'froala-editor/js/froala_editor.min.js';
import 'froala-editor/js/plugins/lists.min.js';
import 'froala-editor/js/plugins/link.min.js';
import 'froala-editor/js/plugins/colors.min.js';
import 'froala-editor/js/plugins/table.min.js';
import 'froala-editor/js/plugins/image.min.js';
import 'froala-editor/js/plugins/paragraph_format.min.js';
import '../legacy/base/forms.js';
